import actionTypes from '../actionTypes';

export const FETCH_REFERRALS = actionTypes('FETCH_REFERRALS');
export const FETCH_REFERRALS_DETAILS = actionTypes('FETCH_REFERRALS_DETAILS');
export const APPROVE_REFERRAL = actionTypes('APPROVE_REFERRAL');
